module["exports"] = [
  "#{street}"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/cz/address/street_name.js
// module id = 1146
// module chunks = 1